// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

// @ts-ignore
import { PatientPortalAuthorizedPatientResponse } from './patient-portal-authorized-patient-response';

/** See com.rev360.pms.api.controller.patient.patientportaluser.PatientPortalUserResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientPortalUserResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	allowLogin!: boolean;

	@GandalfArray(PatientPortalAuthorizedPatientResponse)
	authorizedPatients!: PatientPortalAuthorizedPatientResponse[];

	@GandalfProperty({ designType: Boolean })
	hasPassword!: boolean;

	@GandalfProperty({ designType: String })
	kindeEmail!: string | null;

	@GandalfProperty({ designType: String })
	patientEmail!: string | null;

	@GandalfProperty({ designType: Number })
	patientId!: number;

	@GandalfArray(PatientNameResponse)
	patientPortalRepresentatives!: PatientNameResponse[];

	@GandalfProperty({ designType: String })
	username!: string | null;

}
